import React from 'react';

import { Stack } from '@mui/material';
import { GridRenderCellParams } from '@mui/x-data-grid';

import { Order } from '@luxuryescapes/contract-svc-order';

import customerDataFormatter from './customerDataFormatter';
import orderInformationFormatter from './orderInformationFormatter';

const orderCustomerInformationFormatter = (params: GridRenderCellParams<Order.Order>, customerId?: string) => {
  return (
    <Stack direction="column">
      {orderInformationFormatter(params, customerId)}
      {customerDataFormatter(params)}
    </Stack>
  );
};

export default orderCustomerInformationFormatter;
